{
  "INBOX_MGMT": {
    "HEADER": "Inboxen",
    "DESCRIPTION": "A channel is the mode of communication your customer chooses to interact with you. An inbox is where you manage interactions for a specific channel. It can include communications from various sources such as email, live chat, and social media.",
    "LEARN_MORE": "Learn more about inboxes",
    "RECONNECT": {
      "BUTTON": "Opnieuw verbinden",
      "FACEBOOK": "De verbinding met Facebook is verlopen of ingetrokken. Berichten aan de pagina komen niet in deze inbox aan en antwoorden kunnen mislukken. Iemand die de Facebook-pagina beheert, moet op Opnieuw verbinden klikken en inloggen bij Facebook.",
      "INSTAGRAM": "De verbinding met Instagram is verlopen of ingetrokken. Berichten aan het account komen niet in deze inbox aan en antwoorden kunnen mislukken. Klik op Opnieuw verbinden en log in met hetzelfde Instagram-account. Een ander account maakt een nieuwe inbox aan.",
      "GOOGLE": "De verbinding met Google is verlopen of ingetrokken. Nieuwe e-mails komen niet in deze inbox aan en antwoorden kunnen mislukken. Klik op Opnieuw verbinden en log bij Google in als {email}.",
      "MICROSOFT": "De verbinding met Microsoft is verlopen of ingetrokken. Nieuwe e-mails komen niet in deze inbox aan en antwoorden kunnen mislukken. Klik op Opnieuw verbinden en log bij Microsoft in als {email}.",
      "ALLEGRO": "De verbinding met Allegro is verlopen of ingetrokken. Berichten van kopers komen niet in deze inbox aan en antwoorden kunnen mislukken. Klik op Opnieuw verbinden en log bij Allegro in als verkoper {seller}. Een ander verkopersaccount maakt een nieuwe inbox aan.",
      "IMAP_LOGIN": "De mailserver weigert de IMAP-login {login}. Nieuwe e-mails komen niet in deze inbox aan. Controleer de IMAP-login en het wachtwoord op het tabblad {tab} en sla ze op. Wij blijven proberen in te loggen en de inbox herstelt zich zodra de login werkt.",
      "WHATSAPP": "De verbinding met WhatsApp is verlopen of ingetrokken. Bijlagen van klanten bereiken deze inbox niet, en antwoorden kunnen mislukken. Klik op Opnieuw verbinden, log in bij Facebook en kies opnieuw het nummer {phone}."
    },
    "LIST": {
      "404": "Er zijn geen inboxen aan dit account gekoppeld.",
      "RECONNECT_REQUIRED": "Opnieuw verbinden vereist"
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Kies kanaal",
        "BODY": "Kies de aanbieder die je wilt integreren met de chat."
      },
      "INBOX": {
        "TITLE": "Maak inbox",
        "BODY": "Verifieer je account en maak een inbox."
      },
      "AGENT": {
        "TITLE": "Agenten toevoegen",
        "BODY": "Voeg agenten toe aan de aangemaakte inbox."
      },
      "FINISH": {
        "TITLE": "Voilà!",
        "BODY": "Je bent helemaal klaar om te beginnen!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Inbox Name",
        "PLACEHOLDER": "Enter your inbox name (eg: Acme Inc)",
        "ERROR": "Please enter a valid inbox name"
      },
      "WEBSITE_NAME": {
        "LABEL": "Website naam",
        "PLACEHOLDER": "Voer de naam van je website in (bv. Acme Inc)"
      },
      "INTERNAL_NAME": {
        "LABEL": "Interne naam",
        "PLACEHOLDER": "Naam van de inbox zoals weergegeven in dit dashboard",
        "ERROR": "Voer een unieke interne naam in"
      },
      "FB": {
        "HELP": "PS: Door in te loggen krijgen we alleen toegang tot berichten van uw Pagina. Chatwood heeft nooit toegang tot je privéberichten.",
        "CHOOSE_PAGE": "Kies pagina",
        "CHOOSE_PLACEHOLDER": "Select a page from the list",
        "INBOX_NAME": "Inbox Name",
        "ADD_NAME": "Add a name for your inbox",
        "PICK_NAME": "Pick a Name for your Inbox",
        "PICK_A_VALUE": "Pick a value",
        "CREATE_INBOX": "Inbox aanmaken"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Doorgaan met Instagram",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Verbind je Instagram-profiel",
        "HELP": "Om je Instagram-profiel als kanaal toe te voegen, moet je je Instagram-profiel verifiëren door op 'Doorgaan met Instagram' te klikken ",
        "ERROR_MESSAGE": "Er is een fout opgetreden bij het verbinden met Instagram, probeer het opnieuw",
        "ERROR_AUTH": "Er is een fout opgetreden bij het verbinden met Instagram, probeer het opnieuw",
        "NEW_INBOX_SUGGESTION": "Dit Instagram-account was eerder gekoppeld aan een andere inbox en is nu hierheen gemigreerd. Alle nieuwe berichten verschijnen voortaan hier. De oude inbox kan voor dit account geen berichten meer verzenden of ontvangen.",
        "DUPLICATE_INBOX_BANNER": "Dit Instagram-account is gemigreerd naar de nieuwe Instagram-kanaalinbox. Je kunt vanuit deze inbox geen Instagram-berichten meer verzenden of ontvangen."
      },
      "TWITTER": {
        "HELP": "Om uw Twitterprofiel als kanaal toe te voegen moet u uw Twitterprofiel verifiëren door te klikken op 'Meld je aan met Twitter' ",
        "ERROR_MESSAGE": "There was an error connecting to Twitter, please try again",
        "TWEETS": {
          "ENABLE": "Create conversations from mentioned Tweets"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Website kanaal",
        "DESC": "Maak een kanaal voor uw website en begin met het ondersteunen van uw klanten via onze website widget.",
        "LOADING_MESSAGE": "Website ondersteuningskanaal aanmaken",
        "CHANNEL_AVATAR": {
          "LABEL": "Avatar kanaal"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "Webhook URL",
          "PLACEHOLDER": "Please enter your Webhook URL",
          "ERROR": "Voer een geldige URL in"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Website domein",
          "PLACEHOLDER": "Voer uw website domein in (bv. acme.com)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Welkom op titel",
          "PLACEHOLDER": "Hallo daar!"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Welkom Tagline",
          "PLACEHOLDER": "We maken het eenvoudig om met ons te verbinden. Vraag ons iets of deel uw feedback."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Channel greeting message",
          "PLACEHOLDER": "Acme Inc reageert meestal binnen een paar uur."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Enable channel greeting",
          "HELP_TEXT": "Automatically send a greeting message when a new conversation is created.",
          "ENABLED": "Ingeschakeld",
          "DISABLED": "Uitgeschakeld"
        },
        "REPLY_TIME": {
          "TITLE": "Set Reply time",
          "IN_A_FEW_MINUTES": "In enkele minuten",
          "IN_A_FEW_HOURS": "Over een paar uur",
          "IN_A_DAY": "In één dag",
          "HELP_TEXT": "This reply time will be displayed on the live chat widget"
        },
        "WIDGET_COLOR": {
          "LABEL": "Kleur van widget",
          "PLACEHOLDER": "Update de widget kleur gebruikt in widget"
        },
        "SUBMIT_BUTTON": "Postvak in maken",
        "API": {
          "ERROR_MESSAGE": "We were not able to create a website channel, please try again"
        }
      },
      "TWILIO": {
        "TITLE": "Twilio SMS/WhatsApp Channel",
        "DESC": "Integrate Twilio and start supporting your customers via SMS or WhatsApp.",
        "ACCOUNT_SID": {
          "LABEL": "Klant SID",
          "PLACEHOLDER": "Voer uw Twilio Account-ID in",
          "ERROR": "Dit veld is verplicht"
        },
        "API_KEY": {
          "USE_API_KEY": "Use API Key Authentication",
          "LABEL": "API Key SID",
          "PLACEHOLDER": "Please enter your API Key SID",
          "ERROR": "Dit veld is verplicht"
        },
        "API_KEY_SECRET": {
          "LABEL": "API Key Secret",
          "PLACEHOLDER": "Please enter your API Key Secret",
          "ERROR": "Dit veld is verplicht"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "Messaging Service SID",
          "PLACEHOLDER": "Please enter your Twilio Messaging Service SID",
          "ERROR": "Dit veld is verplicht",
          "USE_MESSAGING_SERVICE": "Use a Twilio Messaging Service"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Kanaaltype",
          "ERROR": "Selecteer uw kanaaltype"
        },
        "AUTH_TOKEN": {
          "LABEL": "Authenticatie Token",
          "PLACEHOLDER": "Voer je Twilio Auth Token in",
          "ERROR": "Dit veld is verplicht"
        },
        "CHANNEL_NAME": {
          "LABEL": "Inbox Name",
          "PLACEHOLDER": "Please enter a inbox name",
          "ERROR": "Dit veld is verplicht"
        },
        "PHONE_NUMBER": {
          "LABEL": "Telefoonnummer",
          "PLACEHOLDER": "Voer het telefoonnummer in waaruit het bericht wordt verzonden.",
          "ERROR": "Please provide a valid phone number that starts with a `+` sign and does not contain any spaces."
        },
        "API_CALLBACK": {
          "TITLE": "Callback URL",
          "SUBTITLE": "U moet de callback URL voor berichten configureren in Twilio met de URL die hier wordt vermeld."
        },
        "SUBMIT_BUTTON": "Twilio-kanaal aanmaken",
        "API": {
          "ERROR_MESSAGE": "Het is niet gelukt om Twilio referenties te verifiëren, probeer het opnieuw"
        }
      },
      "SMS": {
        "TITLE": "SMS-kanaal",
        "DESC": "Start supporting your customers via SMS.",
        "PROVIDERS": {
          "LABEL": "API-aanbieder",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Bandbreedte",
          "SMS_BRANA": "SMS Brana",
          "DIDWW": "DIDWW"
        },
        "API": {
          "ERROR_MESSAGE": "Het SMS-kanaal kon niet worden opgeslagen"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "Account ID",
            "PLACEHOLDER": "Voer uw bandbreedte account-ID in",
            "ERROR": "Dit veld is verplicht"
          },
          "API_KEY": {
            "LABEL": "API sleutel",
            "PLACEHOLDER": "Please enter your Bandwidth API Key",
            "ERROR": "Dit veld is verplicht"
          },
          "API_SECRET": {
            "LABEL": "API-geheim",
            "PLACEHOLDER": "Please enter your Bandwidth API Secret",
            "ERROR": "Dit veld is verplicht"
          },
          "APPLICATION_ID": {
            "LABEL": "Applicatie-ID",
            "PLACEHOLDER": "Please enter your Bandwidth Application ID",
            "ERROR": "Dit veld is verplicht"
          },
          "INBOX_NAME": {
            "LABEL": "Inbox Naam",
            "PLACEHOLDER": "Please enter a inbox name",
            "ERROR": "Dit veld is verplicht"
          },
          "PHONE_NUMBER": {
            "LABEL": "Telefoon nummer",
            "PLACEHOLDER": "Voer het telefoonnummer in waaruit het bericht wordt verzonden.",
            "ERROR": "Please provide a valid phone number that starts with a `+` sign and does not contain any spaces."
          },
          "SUBMIT_BUTTON": "Create Bandwidth Channel",
          "API": {
            "ERROR_MESSAGE": "We were not able to authenticate Bandwidth credentials, please try again"
          },
          "API_CALLBACK": {
            "TITLE": "Callback URL",
            "SUBTITLE": "You have to configure the message callback URL in Bandwidth with the URL mentioned here."
          }
        },
        "SMS_BRANA": {
          "INBOX_NAME": {
            "LABEL": "Inboxnaam",
            "PLACEHOLDER": "Voer een inboxnaam in",
            "ERROR": "Dit veld is verplicht"
          },
          "PHONE_NUMBER": {
            "LABEL": "Telefoonnummer",
            "PLACEHOLDER": "Voer het telefoonnummer in waarvandaan berichten worden verzonden.",
            "ERROR": "Voer een geldig telefoonnummer in dat begint met een `+`-teken."
          },
          "SUBMIT_BUTTON": "SMS Brana-kanaal aanmaken",
          "API": {
            "ERROR_MESSAGE": "Het is niet gelukt om het SMS Brana-kanaal aan te maken"
          }
        },
        "DIDWW": {
          "INBOX_NAME": {
            "LABEL": "Inboxnaam",
            "PLACEHOLDER": "Voer een inboxnaam in",
            "ERROR": "Dit veld is verplicht"
          },
          "PHONE_NUMBER": {
            "LABEL": "Telefoonnummer",
            "PLACEHOLDER": "Voer het telefoonnummer in waarvandaan berichten worden verzonden.",
            "ERROR": "Voer een geldig telefoonnummer in dat begint met een `+`-teken."
          },
          "SUBMIT_BUTTON": "DIDWW-kanaal aanmaken",
          "API": {
            "ERROR_MESSAGE": "Het is niet gelukt om het DIDWW-kanaal aan te maken"
          }
        }
      },
      "WHATSAPP": {
        "PROVIDERS": {
          "LABEL": "API-aanbieder",
          "WHATSAPP_CLOUD": "WhatsApp Cloud"
        },
        "API_CALLBACK": {
          "SUBTITLE": "You have to configure the webhook URL and the verification token in the Facebook Developer portal with the values shown below.",
          "WEBHOOK_URL": "Webhook URL",
          "WEBHOOK_VERIFICATION_TOKEN": "Webhook Verification Token"
        },
        "EMBEDDED_SIGNUP": {
          "TITLE": "Snelle installatie met Meta",
          "DESC": "Je wordt doorgestuurd naar Meta om in te loggen op je WhatsApp Business-account. Beheerderstoegang zorgt voor een soepele en eenvoudige installatie.",
          "BENEFITS": {
            "EASY_SETUP": "Geen handmatige configuratie nodig",
            "SECURE_AUTH": "Veilige authenticatie op basis van OAuth",
            "AUTO_CONFIG": "Automatische configuratie van webhook en telefoonnummer"
          },
          "SUBMIT_BUTTON": "Verbinden met WhatsApp Business",
          "AUTH_PROCESSING": "Authenticeren bij Meta",
          "WAITING_FOR_BUSINESS_INFO": "Voltooi de bedrijfsinstellingen in het Meta-venster...",
          "PROCESSING": "Je WhatsApp Business-account wordt ingesteld",
          "CANCELLED": "Aanmelding bij WhatsApp is geannuleerd",
          "WAITING_FOR_AUTH": "Wachten op authenticatie...",
          "INVALID_BUSINESS_DATA": "Ongeldige bedrijfsgegevens ontvangen van Facebook. Probeer het opnieuw.",
          "SIGNUP_ERROR": "Er is een fout opgetreden bij het aanmelden",
          "SDK_LOAD_ERROR": "De Facebook SDK kon niet worden geladen. Probeer het opnieuw.",
          "AUTH_NOT_COMPLETED": "Authenticatie niet voltooid. Start het proces opnieuw.",
          "SUCCESS_FALLBACK": "WhatsApp Business-account is succesvol geconfigureerd",
          "RECONNECTED": "WhatsApp-kanaal is opnieuw verbonden"
        },
        "API": {
          "ERROR_MESSAGE": "We were not able to save the WhatsApp channel"
        }
      },
      "API_CHANNEL": {
        "TITLE": "API-kanaal",
        "DESC": "Integrate with API channel and start supporting your customers.",
        "CHANNEL_NAME": {
          "LABEL": "Kanaal naam",
          "PLACEHOLDER": "Voer een kanaal naam in",
          "ERROR": "Dit veld is verplicht"
        },
        "WEBHOOK_URL": {
          "LABEL": "Webhook URL",
          "SUBTITLE": "Configure the URL where you want to receive callbacks on events.",
          "PLACEHOLDER": "Webhook URL"
        },
        "SUBMIT_BUTTON": "Create API Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to save the api channel"
        }
      },
      "SALESFORCE_CHANNEL": {
        "TITLE": "Salesforce-kanaal",
        "DESC": "Integreer met het Salesforce-kanaal en begin met het ondersteunen van je klanten.",
        "CHANNEL_NAME": {
          "LABEL": "Kanaalnaam",
          "PLACEHOLDER": "Voer een kanaalnaam in",
          "ERROR": "Dit veld is verplicht"
        },
        "API_BASE_URL": {
          "LABEL": "Salesforce API-URL",
          "SUBTITLE": "Configureer de basis-URL voor je Salesforce-omgeving.",
          "PLACEHOLDER": "URL Salesforce-API"
        },
        "KEY_ID": {
          "LABEL": "Sleutel-ID",
          "SUBTITLE": "Sleutel-ID voor je Salesforce-kanaal.",
          "PLACEHOLDER": "SLEUTEL-ID"
        },
        "SECRET": {
          "LABEL": "Geheim",
          "SUBTITLE": "Geheim voor je Salesforce-kanaal.",
          "PLACEHOLDER": "*****"
        },
        "SUBMIT_BUTTON": "Salesforce-kanaal aanmaken",
        "API": {
          "ERROR_MESSAGE": "Het is niet gelukt om het Salesforce-kanaal op te slaan"
        },
        "API_CALLBACK": {
          "TITLE": "Webhook-URL",
          "SUBTITLE": "Je moet de hier vermelde URL configureren als webhook-URL in Salesforce."
        },
        "BEARER_TOKEN": {
          "TITLE": "Bearer-token",
          "SUBTITLE": "Gebruik dit bearer-token voor authenticatie bij het configureren van de webhook in Salesforce."
        },
        "OVERRIDE_EMAIL_SENDER": {
          "TITLE": "E-mailafzender overschrijven",
          "SUBTITLE": "Indien ingesteld, wordt dit e-mailadres gebruikt als afzender voor alle uitgaande e-mails in plaats van het bron-e-mailadres van het gesprek.",
          "PLACEHOLDER": "bijv. support{'@'}example.com"
        }
      },
      "ALLEGRO_CHANNEL": {
        "TITLE": "Allegro-kanaal",
        "DESC": "Koppel een Allegro-verkopersaccount en beantwoord het berichtencentrum vanuit het contactcenter.",
        "CHANNEL_NAME": {
          "LABEL": "Inboxnaam",
          "SUBTITLE": "De naam die agenten voor deze inbox zien.",
          "PLACEHOLDER": "Voer een inboxnaam in",
          "ERROR": "Dit veld is verplicht"
        },
        "SUBMIT_BUTTON": "Inloggen met Allegro",
        "API": {
          "ERROR_MESSAGE": "Er is een fout opgetreden bij het verbinden met Allegro, probeer het opnieuw"
        },
        "SELLER_LOGIN": {
          "TITLE": "Allegro-login",
          "SUBTITLE": "Het verkopersaccount waarvoor deze inbox berichten leest en beantwoordt."
        }
      },
      "KAUFLAND_CHANNEL": {
        "TITLE": "Kaufland-kanaal",
        "DESC": "Beantwoord de ticketberichten die kopers u sturen op de Kaufland-marktplaats.",
        "CHANNEL_NAME": {
          "LABEL": "Kanaal naam",
          "PLACEHOLDER": "Voer een kanaal naam in",
          "ERROR": "Dit veld is verplicht"
        },
        "CLIENT_KEY": {
          "LABEL": "Client Key",
          "SUBTITLE": "De Client Key van 32 tekens op de API-instellingenpagina van uw Kaufland-verkopersaccount.",
          "PLACEHOLDER": "Sleutel van 32 tekens",
          "ERROR": "Voer de Client Key van 32 tekens in"
        },
        "SECRET_KEY": {
          "LABEL": "Secret Key",
          "SUBTITLE": "De Secret Key van 64 tekens die bij de Client Key hoort. Kaufland toont deze één keer en stuurt hem nooit terug naar deze pagina.",
          "PLACEHOLDER": "Sleutel van 64 tekens",
          "ERROR": "Voer de Secret Key van 64 tekens in"
        },
        "SUBMIT_BUTTON": "Kaufland-kanaal maken",
        "API": {
          "ERROR_MESSAGE": "We konden het Kaufland-kanaal niet opslaan"
        },
        "DISCONNECTED": {
          "TITLE": "Niet verbonden",
          "MESSAGE": "Kaufland heeft deze API-sleutels geweigerd. Voer de client key en de secret key opnieuw in om deze inbox weer te verbinden."
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "Email Channel",
        "DESC": "Integrate your email inbox.",
        "CHANNEL_NAME": {
          "LABEL": "Kanaal naam",
          "PLACEHOLDER": "Voer een kanaal naam in",
          "ERROR": "Dit veld is verplicht"
        },
        "EMAIL": {
          "LABEL": "E-mailadres",
          "SUBTITLE": "Email where your customers sends you support tickets",
          "PLACEHOLDER": "E-mailadres"
        },
        "SUBMIT_BUTTON": "Create Email Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to save the email channel"
        },
        "FINISH_MESSAGE": "Start forwarding your emails to the following email address."
      },
      "LINE_CHANNEL": {
        "TITLE": "LINE-kanaal",
        "DESC": "Integrate with LINE channel and start supporting your customers.",
        "CHANNEL_NAME": {
          "LABEL": "Kanaal naam",
          "PLACEHOLDER": "Voer een kanaal naam in",
          "ERROR": "Dit veld is verplicht"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "LINE Channel ID",
          "PLACEHOLDER": "LINE Channel ID"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "LINE Channel Secret",
          "PLACEHOLDER": "LINE Channel Secret"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "LINE Channel Token",
          "PLACEHOLDER": "LINE Channel Token"
        },
        "SUBMIT_BUTTON": "Create LINE Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to save the LINE channel"
        },
        "API_CALLBACK": {
          "TITLE": "Callback URL",
          "SUBTITLE": "You have to configure the webhook URL in LINE application with the URL mentioned here."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Telegram Channel",
        "DESC": "Integrate with Telegram channel and start supporting your customers.",
        "BOT_TOKEN": {
          "LABEL": "Bot Token",
          "SUBTITLE": "Configure the bot token you have obtained from Telegram BotFather.",
          "PLACEHOLDER": "Bot Token"
        },
        "SUBMIT_BUTTON": "Create Telegram Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to save the telegram channel"
        }
      },
      "PHONE_CHANNEL": {
        "TITLE": "Telefoongesprekken",
        "DESC": "Stel in welke telefoongesprekken onder deze inbox worden weergegeven.",
        "NAME": {
          "LABEL": "Inboxnaam",
          "SUBTITLE": "Kies een gemakkelijk herkenbare naam."
        },
        "PHONE_NUMBER": {
          "LABEL": "Telefoonnummer",
          "SUBTITLE": "Voer telefoonnummers in die bij deze inbox horen, je kunt later meer nummers toevoegen.",
          "PLACEHOLDER": "+421123908635"
        },
        "SUBMIT_BUTTON": "Inbox voor telefoongesprekken aanmaken",
        "API": {
          "ERROR_MESSAGE": "Het is niet gelukt om de inbox aan te maken"
        }
      },
      "AUTH": {
        "TITLE": "Kies een kanaal",
        "DESC": "De chat ondersteunt livechatwidgets, Facebook Messenger, WhatsApp, e-mails, enz. als kanalen. Als je een eigen kanaal wilt bouwen, kun je het maken met het API-kanaal. Kies een van de onderstaande kanalen om te beginnen."
      },
      "AGENTS": {
        "TITLE": "Agenten",
        "DESC": "Hier kunt u agenten toevoegen om uw nieuw gecreëerde inbox te beheren. Alleen deze agenten hebben toegang tot uw inbox. Agents die geen deel uitmaken van dit postvak in zullen niet in staat zijn om berichten in dit postvak te zien of te reageren wanneer ze inloggen. <br> <b>PS:</b> Als beheerder als u toegang wilt krijgen tot alle inboxen, voeg jezelf toe als agent aan alle inboxen die je maakt.",
        "VALIDATION_ERROR": "Add at least one agent to your new Inbox",
        "PICK_AGENTS": "Pick agents for the inbox"
      },
      "DETAILS": {
        "TITLE": "Details inbox",
        "DESC": "Selecteer de Facebook-pagina die je wilt verbinden met Chatwood uit de dropdown hieronder. U kunt ook een aangepaste naam geven aan uw inbox voor een betere identificatie."
      },
      "FINISH": {
        "TITLE": "Geïnstalleerd het!",
        "DESC": "U heeft de integratie van uw Facebook-pagina met de chat succesvol voltooid. Volgende keer dat een klant uw pagina bericht, zal het gesprek automatisch in uw inbox verschijnen.<br>We bieden u ook een widget script aan, dat u eenvoudig aan uw website kunt toevoegen. Zodra dit live is op je website klanten kunnen vanaf uw website een bericht sturen zonder de hulp van een externe tool en het gesprek verschijnt hier in de chat.<br>Koel, toch? Wel, proberen we zeker om te zijn :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "Select your email provider",
        "DESCRIPTION": "Select an email provider from the list below. If you don't see your email provider in the list, you can select the other provider option and provide the IMAP and SMTP Credentials."
      },
      "MICROSOFT": {
        "TITLE": "Microsoft Email",
        "DESCRIPTION": "Click on the Sign in with Microsoft button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "SIGN_IN": "Sign in with Microsoft",
        "ERROR_MESSAGE": "There was an error connecting to Microsoft, please try again"
      },
      "GOOGLE": {
        "TITLE": "Google Email",
        "DESCRIPTION": "Click on the Sign in with Google button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "SIGN_IN": "Sign in with Google",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "ERROR_MESSAGE": "There was an error connecting to Google, please try again"
      }
    },
    "DETAILS": {
      "LOADING_FB": "Verifiëren met Facebook...",
      "ERROR_FB_LOADING": "Error loading Facebook SDK. Please disable any ad-blockers and try again from a different browser.",
      "ERROR_FB_AUTH": "Er ging iets mis, gelieve pagina te vernieuwen...",
      "ERROR_FB_UNAUTHORIZED": "You're not authorized to perform this action. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Please ensure you have access to the Facebook page with full control. You can read more about Facebook roles <a href=\" https://www.facebook.com/help/187316341316631\">here</a>.",
      "ERROR_CHANNEL_CREATION": "We konden het postvak niet aanmaken. Probeer het opnieuw.",
      "CREATING_CHANNEL": "Uw postvak wordt gemaakt...",
      "TITLE": "Configureer Postvak in details",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Voeg agenten toe",
      "ADD_AGENTS": "Agents toevoegen aan uw Postvak IN..."
    },
    "FINISH": {
      "TITLE": "Uw postvak is klaar!",
      "MESSAGE": "Je kunt nu contact opnemen met je klanten via het nieuwe Kanaal. Gelukkige ondersteuning",
      "BUTTON_TEXT": "Breng me ernaar toe",
      "MORE_SETTINGS": "More settings",
      "WEBSITE_SUCCESS": "Het aanmaken van een website kanaal is gelukt. Kopieer de code hieronder weergegeven en plak deze op uw website. De volgende keer dat een klant de live chat gebruikt, verschijnt het gesprek automatisch op uw inbox."
    },
    "REAUTH": "Autoriseer",
    "VIEW": "Bekijken",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "Inbox instellingen succesvol bijgewerkt",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Automatische toewijzing succesvol bijgewerkt",
        "ERROR_MESSAGE": "We couldn't update inbox settings. Please try again later."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Ingeschakeld",
        "DISABLED": "Uitgeschakeld"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Ingeschakeld",
        "DISABLED": "Uitgeschakeld"
      },
      "ENABLE_CSAT_ON_EACH_MESSAGE": {
        "ENABLED": "Ingeschakeld",
        "DISABLED": "Uitgeschakeld"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Sender name",
        "SUB_TEXT": "Select the name shown to your customer when they receive emails from your agents.",
        "FOR_EG": "For eg:",
        "FRIENDLY": {
          "TITLE": "Vriendelijk",
          "FROM": "van",
          "SUBTITLE": "Add the name of the agent who sent the reply in the sender name to make it friendly."
        },
        "PROFESSIONAL": {
          "TITLE": "Professioneel",
          "SUBTITLE": "Use only the configured business name as the sender name in the email header."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "+ Configure your business name",
          "PLACEHOLDER": "Enter your business name",
          "SAVE_BUTTON_TEXT": "Opslaan"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Ingeschakeld",
        "DISABLED": "Uitgeschakeld"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Ingeschakeld",
        "DISABLED": "Uitgeschakeld"
      },
      "RESPOND_FROM_EMAIL": {
        "NONE": "Geen"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Ingeschakeld",
        "DISABLED": "Uitgeschakeld"
      },
      "ENABLE_HMAC": {
        "LABEL": "Enable"
      },
      "FORCE_NEW_CONVERSATION_PER_LOAD": {
        "ENABLED": "Ingeschakeld",
        "DISABLED": "Uitgeschakeld"
      },
      "NEW_CONVERSATION_FORGETS_CONTACT": {
        "ENABLED": "Ingeschakeld",
        "DISABLED": "Uitgeschakeld"
      },
      "ENABLE_EMAIL_FETCHING": {
        "LABEL": "Synchronisatie van inkomende e-mails inschakelen"
      },
      "ENABLE_CUSTOM_EMAIL": {
        "LABEL": "Aangepast e-maildomein inschakelen (betaalde dienst)."
      },
      "ENABLE_FACEBOOK_COMMENTS": {
        "LABEL": "Verwerking van Facebook-reacties inschakelen"
      },
      "SIGNATURE": {
        "TITLE": "HTML-handtekening",
        "SUB_TEXT": "Deze handtekening wordt toegevoegd aan de voettekst van elk bericht dat vanuit deze inbox wordt verzonden.",
        "HTML_CONTENT": "HTML-code",
        "HTML_CONTENT_HELP": "{'{{'}name{'}}'} wordt vervangen door de naam van de agent.\n{'{{'}email{'}}'} wordt vervangen door het e-mailadres van de agent die de e-mail heeft verzonden.\n{'{{'}position{'}}'} wordt vervangen door de functie van de agent.\n{'{{'}custom_line{'}}'} wordt vervangen door de aangepaste regel van de agent.\n{'{{'}email_signature_picture{'}}'} wordt vervangen door de URL van de afbeelding voor de e-mailhandtekening van de agent (geen afbeeldingstag) — gebruik dit als afbeeldingsbron (de src van een img-tag).",
        "PREVIEW": "Voorbeeld"
      },
      "COUNTRY_SIGNATURES": {
        "TITLE": "Handtekeningen per land",
        "SUB_TEXT": "Een antwoord krijgt de handtekening van het land van de koper.",
        "HELP": "Een antwoord wordt ondertekend volgens het land van het gesprek: de Kaufland-winkel, de marktplaats van de Allegro-bestelling, of anders de taal waarin de koper schrijft. Als het land onbekend is of hier geen handtekening heeft, wordt de HTML-handtekening hierboven gebruikt. Marktplaatsen verbieden links naar je website en contactgegevens, dus houd het bij een groet en {'{{'}name{'}}'}.",
        "EMPTY": "Je hebt nog geen landhandtekeningen, dus antwoorden gebruiken de HTML-handtekening hierboven.",
        "COUNTRY": "Selecteer een land",
        "ADD": "Landhandtekening toevoegen",
        "REMOVE": "Verwijderen"
      },
      "PHONE_DIALING_PREFIX": {
        "LABEL": "Belvoorvoegsel voor telefoonnummer",
        "PLACEHOLDER": "Voer een voorvoegsel in voor correcte gespreksroutering (bijv. *99)",
        "HELP_TEXT": "Dit voorvoegsel wordt automatisch toegevoegd vóór contacttelefoonnummers bij het bellen vanuit deze inbox."
      },
      "RESOLVE_LATER_TEXT": {
        "LABEL": "Tekst van de knop 'Later oplossen'",
        "PLACEHOLDER": "bijv. We lossen dit onderwerp op via e-mail. Ik wil nu over iets anders vragen.",
        "HELP_TEXT": "Label van de knop in de widget waarmee de bezoeker het huidige onderwerp verlaat en over iets anders vraagt. Laat het veld leeg om de standaardtekst in de taal van de bezoeker te gebruiken."
      },
      "AUTO_SNOOZE_MINUTES": {
        "LABEL": "Gemiste oproepen automatisch snoozen voor X minuten",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Snooze gemiste oproepen automatisch voor het opgegeven aantal minuten. Laat leeg of vul 0 in om uit te schakelen."
      },
      "AUTO_RESOLVE_AFTER_FAILED_ATTEMPTS": {
        "LABEL": "Gemiste oproep oplossen na X mislukte terugbelpogingen",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Als een gemiste oproep X keer is teruggebeld zonder dat de klant opneemt, wordt deze automatisch opgelost en wordt er een privénotitie toegevoegd. Laat leeg of vul 0 in om uit te schakelen."
      },
      "QUESTION_SUGGESTIONS": {
        "TITLE": "Vraagsuggesties",
        "SUB_TEXT": "Configureer vooraf gedefinieerde vragen die klanten kunnen gebruiken om met je agenten te communiceren.",
        "QUESTIONS_LABEL": "Vragen",
        "ADD_QUESTION": "Vraag toevoegen",
        "REMOVE": "Verwijderen",
        "QUESTION_TEXT": "Tekst die in de ballon wordt weergegeven.",
        "QUESTION_TEXT_PLACEHOLDER": "Verplicht",
        "QUESTION_PAYLOAD": "Tekst die wordt verzonden bij een klik.",
        "QUESTION_PAYLOAD_PLACEHOLDER": "Optioneel",
        "NO_BOT_MESSAGE": "Verbind een bot om extra AI-suggesties te genereren.",
        "BOT_CONNECTED_MESSAGE": "AI-vraagsuggesties van de bot kunnen worden geactiveerd in de",
        "BOT_SETTINGS_LINK": "instellingen"
      },
      "ALTERNATIVE_EMAILS": {
        "TITLE": "Alternatieve e-mailadressen",
        "SUB_TEXT": "Aanvullende adressen die deze inbox als eigen moet behandelen bij het ontvangen van doorgestuurde e-mail.",
        "PLACEHOLDER": "alias{'@'}example.com",
        "ADD": "Toevoegen",
        "REMOVE": "Verwijderen",
        "EMPTY": "Geen alternatieve e-mailadressen geconfigureerd.",
        "HELP_TEXT": "Wanneer een e-mail binnenkomt met een van deze adressen als ontvanger, worden antwoorden verzonden met hetzelfde adres als afzender. Zorg ervoor dat uw uitgaande SMTP-server verzending vanaf deze adressen toestaat.",
        "SIGNATURE_LABEL": "Handtekening",
        "PRIMARY_SIGNATURE": "Primair (standaard)"
      },
      "ADDITIONAL_SIGNATURES": {
        "TITLE": "Extra handtekeningen",
        "SUB_TEXT": "Definieer hier extra handtekeningen en wijs ze vervolgens toe aan de alternatieve e-mails hieronder.",
        "OPTION": "Handtekening {number}",
        "ADD": "Handtekening toevoegen",
        "REMOVE": "Verwijderen",
        "HELP_TEXT": "Wanneer een antwoord vanuit een alternatief e-mailadres wordt verzonden, wordt de daaraan toegewezen handtekening gebruikt in plaats van de handtekening van de inbox. Alternatieve e-mailadressen die op „Primair (standaard)” blijven staan, vallen terug op de handtekening van de inbox."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Verwijderen",
      "AVATAR_DELETE_BUTTON_TEXT": "Delete Avatar",
      "DELETE_REQUESTED_TOOLTIP": "Deze inbox is gemarkeerd voor verwijdering",
      "RESTORE_BUTTON_TEXT": "Herstellen",
      "CONFIRM": {
        "TITLE": "Verwijdering bevestigen",
        "MESSAGE": "Weet u zeker dat u wilt verwijderen ",
        "PLACE_HOLDER": "Please type {inboxName} to confirm",
        "YES": "Ja, verwijderen ",
        "NO": "Nee, Behouden "
      },
      "API": {
        "SUCCESS_MESSAGE": "Inbox succesvol verwijderd",
        "MARKED_FOR_DELETION_MESSAGE": "Inbox gemarkeerd voor verwijdering",
        "RESTORE_SUCCESS_MESSAGE": "Inbox succesvol hersteld",
        "ERROR_MESSAGE": "Postvak verwijderen mislukt. Probeer het later opnieuw.",
        "RESTORE_ERROR_MESSAGE": "Kan de inbox niet herstellen. Probeer het later opnieuw.",
        "AVATAR_SUCCESS_MESSAGE": "Inbox avatar deleted successfully",
        "AVATAR_ERROR_MESSAGE": "Could not delete the inbox avatar. Please try again later."
      }
    },
    "TABS": {
      "SETTINGS": "Instellingen",
      "COLLABORATORS": "Collaborators",
      "AUTOMATIC_PRIORITY": "Automatische prioriteit",
      "AUTOMATIC_LABELING": "Automatisch labelen",
      "CONFIGURATION": "Configuration",
      "CAMPAIGN": "Campagnes",
      "PRE_CHAT_FORM": "Pre Chat Form",
      "BUSINESS_HOURS": "Business Hours",
      "WIDGET_BUILDER": "Widget Builder",
      "BOT_CONFIGURATION": "Bot Configuration",
      "SLA": "SLA"
    },
    "SETTINGS": "Instellingen",
    "FEATURES": {
      "LABEL": "Features",
      "DISPLAY_FILE_PICKER": "Display file picker on the widget",
      "DISPLAY_EMOJI_PICKER": "Display emoji picker on the widget",
      "ALLOW_END_CONVERSATION": "Allow users to end conversation from the widget",
      "SHOW_START_NEW_CONVERSATION_BUTTON": "Toon de knop 'Nieuw gesprek starten' in de widgetkop",
      "HIDE_INPUT_UNDER_START_NEW_CONVERSATION_BUTTON": "Hide input field when start new conversation button is shown",
      "SHOW_HANDOFF_BUTTON": "Toon de knop 'Doorverbinden met een medewerker' in de widgetkop",
      "AUTO_CLOSE_OLD": "Markeer alle eerdere oproepen van hetzelfde nummer als opgelost zodra er één is opgelost",
      "AUTO_ASSIGN_MISSED_ON_OUTGOING": "Wijs gemiste oproepen automatisch toe bij het plaatsen van een uitgaande oproep",
      "USE_INBOX_AVATAR_FOR_BOT": "Use inbox name and avatar for the bot",
      "ALLOW_OFFLINE_REPLY": "Sta agenten toe berichten te verzenden wanneer het contact offline is en e-mailcontinuïteit niet beschikbaar is"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Messenger Script",
      "MESSENGER_SUB_HEAD": "Plaats deze knop in je lichaam tag",
      "INBOX_AGENTS": "Agenten",
      "INBOX_TEAMS": "Teams",
      "INBOX_COOPERATORS": "Samenwerkers",
      "SELECT_PLACEHOLDER": "Selecteer",
      "AGENTS_OR_TEAMS_INFO": "Je kunt óf agenten óf teams toewijzen - niet allebei tegelijk.",
      "INBOX_AGENTS_SUB_TEXT": "Voeg agenten toe of verwijder ze uit deze inbox",
      "AGENT_ASSIGNMENT": "Conversation Assignment",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Update conversation assignment settings",
      "UPDATE": "Vernieuwen",
      "ENABLE_EMAIL_COLLECT_BOX": "Enable email collect box",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "Enable or disable email collect box on new conversation",
      "AUTO_ASSIGNMENT": "Automatische toewijzing inschakelen",
      "ENABLE_CSAT": "Enable CSAT",
      "ENABLE_CSAT_ON_EACH_MESSAGE": "CSAT inschakelen voor elk bericht",
      "SENDER_NAME_SECTION": "Enable Agent Name in Email",
      "ENABLE_CSAT_SUB_TEXT": "Enable/Disable CSAT(Customer satisfaction) survey after resolving a conversation",
      "ENABLE_CSAT_ON_EACH_MESSAGE_SUB_TEXT": "Schakel de CSAT-enquête in of uit voor elk bericht dat door agenten wordt verzonden",
      "SENDER_NAME_SECTION_TEXT": "Enable/Disable showing Agent's name in email, if disabled it will show business name",
      "ENABLE_CONTINUITY_VIA_EMAIL": "Enable conversation continuity via email",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "Conversations will continue over email if the contact email address is available.",
      "RESPOND_FROM_EMAIL": "Antwoorden vanaf e-mailadres",
      "RESPOND_FROM_EMAIL_SUB_TEXT_WEBWIDGET": "E-mails naar de klant — zowel antwoorden als gespreksoverzichten — worden verzonden via de SMTP-instellingen van de geselecteerde e-mailinbox, vanaf het geselecteerde adres (het eigen adres van de inbox of een van de aliassen ervan), en de antwoorden van de klant komen terug binnen via het IMAP-adres ervan.",
      "RESPOND_FROM_EMAIL_SUB_TEXT_OTHER": "Gespreksoverzichten worden verzonden via de SMTP-instellingen van de geselecteerde e-mailinbox, vanaf het geselecteerde adres (het eigen adres van de inbox of een van de aliassen ervan), waarbij antwoorden terugkomen via het IMAP-adres ervan.",
      "SHOW_WELCOME_SCREEN": "Welkomstscherm tonen",
      "SHOW_WELCOME_SCREEN_TOOLTIP": "Toon het welkomstscherm wanneer de widget wordt geopend. Indien uitgeschakeld, gaat de widget direct naar de gespreksweergave.",
      "AUTO_CLOSE_PENDING": "AI-chats automatisch oplossen na (uren)",
      "AUTO_CLOSE_PENDING_SUB_TEXT": "Los AI-chats automatisch op na X uur inactiviteit.",
      "LOCK_TO_SINGLE_CONVERSATION": "Lock to single conversation",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Enable or disable multiple conversations for the same contact in this inbox",
      "INBOX_UPDATE_TITLE": "Instellingen Postvak In",
      "INBOX_UPDATE_SUB_TEXT": "Update uw inbox instellingen",
      "AUTO_ASSIGNMENT_SUB_TEXT": "In- of uitschakelen van de automatische toewijzing van nieuwe gesprekken aan de agenten die aan deze inbox zijn toegevoegd.",
      "HMAC_VERIFICATION": "User Identity Validation",
      "HMAC_DESCRIPTION": "In order to validate the user's identity, you can pass an `identifier_hash` for each user. You can generate a HMAC sha256 hash using the `identifier` with the key shown here.",
      "HMAC_ROTATE": {
        "BUTTON": "Sleutel roteren",
        "TITLE": "Geheime sleutel roteren?",
        "WARNING": "De huidige sleutel wordt ingetrokken zodra u deze roteert.",
        "WARNING_DETAIL": "Er is geen overlapperiode en de sleutel kan niet worden hersteld.",
        "IMPACT": "Uw servers moeten gebruikers met de nieuwe sleutel ondertekenen. Iedereen die nog met de oude sleutel is ondertekend, faalt de verificatie. Als identiteitsvalidatie verplicht is, kan diegene geen gesprek starten.",
        "CONFIRM": "Sleutel roteren",
        "CANCEL": "Annuleren",
        "SUCCESS": "Geheime sleutel succesvol geroteerd",
        "ERROR": "Kon de geheime sleutel niet roteren, probeer het opnieuw"
      },
      "HMAC_LINK_TO_DOCS": "You can read more here.",
      "HMAC_MANDATORY_VERIFICATION": "Enforce User Identity Validation",
      "HMAC_MANDATORY_DESCRIPTION": "If enabled, requests missing the `identifier_hash` will be rejected.",
      "FORCE_NEW_CONVERSATION_PER_LOAD_TITLE": "Nieuw gesprek forceren bij elke keer dat de widget wordt geladen",
      "FORCE_NEW_CONVERSATION_PER_LOAD_SUBTITLE": "Indien ingeschakeld, start het openen van de widget in een nieuw tabblad of venster een nieuw gesprek.",
      "NEW_CONVERSATION_FORGETS_CONTACT_TITLE": "Contact vergeten wanneer een nieuw gesprek wordt gestart",
      "NEW_CONVERSATION_FORGETS_CONTACT_SUBTITLE": "Indien uitgeschakeld, behoudt een nieuw gesprek dat vanuit de widget wordt gestart het vorige contact.",
      "INBOX_IDENTIFIER": "Inbox Identifier",
      "INBOX_IDENTIFIER_SUB_TEXT": "Use the `inbox_identifier` token shown here to authentication your API clients.",
      "FORWARD_EMAIL_TITLE": "Forward to Email",
      "FORWARD_EMAIL_SUB_TEXT": "Start forwarding your emails to the following email address.",
      "EMAIL_FETCHING_ENABLED_TITLE": "E-mailsynchronisatie",
      "EMAIL_FETCHING_ENABLED_DESCRIPTION": "Schakel automatische synchronisatie en het downloaden van inkomende e-mails van deze inbox in",
      "CUSTOM_EMAIL_ENABLED_TITLE": "Aangepast e-maildomein",
      "CUSTOM_EMAIL_ENABLED_DESCRIPTION": "Schakel in om een aangepast e-maildomein te gebruiken voor uitgaande e-mails",
      "CUSTOM_EMAIL_ENABLED_LINK_TO_DOCS": "Je kunt hier meer lezen.",
      "FACEBOOK_COMMENTS_TITLE": "Facebook-reacties",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Allow messages after conversation resolved",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Allow the end-users to send messages even after the conversation is resolved.",
      "WIDGET_STATUS_LABEL": "Widgetstatus",
      "WIDGET_STATUS_ENABLED": "Ingeschakeld",
      "WIDGET_STATUS_BUSINESS_HOURS": "Ingeschakeld tijdens openingstijden",
      "WIDGET_STATUS_DISABLED": "Uitgeschakeld",
      "WIDGET_STATUS_HELP_TEXT": "Bepaal wanneer de widget wordt getoond aan bezoekers van je website",
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Update Pre Chat Form Settings",
      "EXPLICIT_CSAT_LOCALE": "Taal voor CSAT-enquête en e-mail",
      "EXPLICIT_CSAT_LOCALE_SUB_TEXT": "Kies de taal voor alle e-mails aan klanten, waaronder CSAT-enquêtes, gespreksoverzichten en e-mailmeldingen",
      "EXPLICIT_CSAT_LOCALE_INHERIT": "Overnemen van account",
      "WHATSAPP_CONNECTION": {
        "TITLE": "WhatsApp-verbinding",
        "SUBTITLE": "Hoe deze inbox met WhatsApp is verbonden.",
        "PROVIDER": "Provider",
        "PROVIDER_VALUE": "WhatsApp Cloud API (Meta)",
        "EMBEDDED_SIGNUP": "Verbonden via de ingebouwde aanmelding van Meta",
        "STATUS": "Status",
        "CONNECTED": "Verbonden",
        "RECONNECT_HINT": "Klik op Opnieuw verbinden in de melding hierboven.",
        "PHONE_NUMBER": "Telefoonnummer",
        "BUSINESS_ACCOUNT": "WhatsApp Business-account-ID",
        "OPEN_MANAGER": "Openen in WhatsApp Manager",
        "PHONE_NUMBER_ID": "Telefoonnummer-ID",
        "TEMPLATES": "Berichtsjablonen",
        "TEMPLATES_COUNT": "{approved} van {total} goedgekeurd",
        "TEMPLATES_SYNCED": "Laatst gesynchroniseerd: {date}",
        "TEMPLATES_NOT_SYNCED": "Nog niet gesynchroniseerd",
        "MANAGE_TEMPLATES": "Sjablonen beheren"
      }
    },
    "HELP_CENTER": {
      "LABEL": "Help Center",
      "PLACEHOLDER": "Select Help Center",
      "SELECT_PLACEHOLDER": "Select Help Center",
      "REMOVE": "Remove Help Center",
      "SUB_TEXT": "Attach a Help Center with the inbox"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Auto assignment limit",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Please enter a value greater than 0",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Limit the maximum number of conversations from this inbox that can be auto assigned to an agent"
    },
    "SLA": {
      "TITLE": "SLA-beleid",
      "SUB_TEXT": "Configureer SLA-reactie- en oplostijden voor elk prioriteitsniveau van gesprekken.",
      "LOADING": "SLA-beleid laden...",
      "FIELDS": {
        "ACTIVE": "Actief",
        "TICKET_PRIORITY": "Ticketprioriteit",
        "FIRST_RESPONSE_TIME": "Eerste reactietijd",
        "EVERY_RESPONSE_TIME": "Elke reactietijd",
        "RESOLUTION_TIME": "Resolutietijd",
        "PLACEHOLDER": "bijv. 1u 30m"
      },
      "API": {
        "SUCCESS_MESSAGE": "SLA-beleid succesvol bijgewerkt.",
        "ERROR_MESSAGE": "Kan het SLA-beleid niet bijwerken. Probeer het opnieuw."
      }
    },
    "AUTOMATIC_PRIORITY": {
      "TITLE": "Automatische prioriteit",
      "SUB_TEXT": "Configureer automatische prioriteitstoewijzing op basis van de inhoud van het gesprek.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Factureringsmelding",
        "MESSAGE": "Elke prioriteitsbeoordeling brengt kosten met zich mee. Bekijk de details van je abonnement voor prijsinformatie."
      },
      "MODE": {
        "OFF": "Uit",
        "ALL_MESSAGES": "Aan voor alle inkomende berichten",
        "FIRST_MESSAGE": "Alleen aan voor het eerste inkomende bericht"
      },
      "PRIORITY_LEVELS": {
        "TITLE": "Configuratie van prioriteitsniveaus",
        "SUB_TEXT": "Configureer welke prioriteitsniveaus moeten worden ingeschakeld en hun beschrijvingen. Geef duidelijke criteria op zodat AI kan bepalen wanneer deze prioriteit moet worden toegewezen."
      },
      "DESCRIPTION_LABEL": "Beschrijving",
      "DESCRIPTION_PLACEHOLDER": "Beschrijf gesprekken die moeten worden gemarkeerd met prioriteit {priority}",
      "SET_AS_DEFAULT": "Instellen als standaardprioriteit",
      "MULTIPLE_DEFAULTS_WARNING": "Er mag maar één prioriteitsniveau als standaard zijn ingesteld. Schakel de andere standaardinstellingen uit."
    },
    "AUTOMATIC_LABELING": {
      "TITLE": "Automatisch labelen",
      "SUB_TEXT": "Configureer automatische labeltoewijzing op basis van de inhoud van het gesprek.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Factureringsmelding",
        "MESSAGE": "Elke labelbeoordeling brengt kosten met zich mee. Bekijk de details van je abonnement voor prijsinformatie."
      },
      "MODE": {
        "OFF": "Uit",
        "CONVERSATION_OPEN": "Bij het openen van het gesprek",
        "CONVERSATION_CLOSE": "Bij het sluiten van het gesprek",
        "ALL_MESSAGES": "Bij elk bericht - ongeacht de status",
        "FIRST_MESSAGE": "Bij het eerste bericht - ongeacht de status"
      },
      "LABEL_CONFIGURATION": {
        "TITLE": "Labelconfiguratie",
        "SUB_TEXT": "Configureer welke labels beschikbaar moeten zijn voor automatische toewijzing en hun beschrijvingen. Geef duidelijke criteria op zodat AI kan bepalen wanneer dit label moet worden toegepast."
      },
      "DESCRIPTION_LABEL": "Beschrijving",
      "DESCRIPTION_PLACEHOLDER": "Beschrijf gesprekken die moeten worden gelabeld als {label}. Als je dit leeg laat, wordt de labelbeschrijving gebruikt.",
      "NO_LABELS_MESSAGE": "Geen labels gevonden. Maak eerst labels aan om automatisch labelen in te schakelen.",
      "CREATE_LABELS_LINK": "Labels aanmaken"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Autoriseer",
      "SUBTITLE": "Your Facebook connection has expired, please reconnect your Facebook page to continue services",
      "MESSAGE_SUCCESS": "Reconnection successful",
      "MESSAGE_ERROR": "Er is een fout opgetreden, probeer het opnieuw"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "Pre chat forms enable you to capture user information before they start conversation with you.",
      "SET_FIELDS": "Pre chat form fields",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Fields",
        "LABEL": "Label",
        "PLACE_HOLDER": "Placeholder",
        "KEY": "Sleutel",
        "TYPE": "Type",
        "REQUIRED": "Required"
      },
      "ENABLE": {
        "LABEL": "Enable pre chat form",
        "OPTIONS": {
          "ENABLED": "Yes",
          "DISABLED": "No"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Pre chat message",
        "PLACEHOLDER": "This message would be visible to the users along with the form"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "Visitors should provide their name and email address before starting the chat"
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Set your availability",
      "SUBTITLE": "Set your availability on your livechat widget",
      "WEEKLY_TITLE": "Set your weekly hours",
      "TIMEZONE_LABEL": "Select timezone",
      "UPDATE": "Update business hours settings",
      "TOGGLE_AVAILABILITY": "Enable business availability for this inbox",
      "UNAVAILABLE_MESSAGE_LABEL": "Unavailable message for visitors",
      "TOGGLE_HELP": "Enabling business availability will show the available hours on live chat widget even if all the agents are offline. Outside available hours visitors can be warned with a message and a pre-chat form.",
      "DAY": {
        "ENABLE": "Enable availability for this day",
        "UNAVAILABLE": "Unavailable",
        "HOURS": "hours",
        "VALIDATION_ERROR": "Starting time should be before closing time.",
        "CHOOSE": "Choose"
      },
      "ALL_DAY": "All-Day",
      "SAVE_TO_ALL": "Opslaan voor alle inboxen",
      "SAVE_TO_ALL_TITLE": "Werktijden kopiëren",
      "SAVE_TO_ALL_CONFIRM": "De instellingen van dit formulier (beschikbaarheidsschakelaar, afwezigheidsbericht, tijdzone en werktijden) worden gekopieerd naar alle andere inboxen, behalve e-mail- en telefoon-inboxen. Weet je zeker dat je wilt doorgaan?",
      "SAVE_TO_ALL_CANCEL": "Annuleren",
      "SAVE_TO_ALL_YES": "Ja, kopiëren naar alle",
      "SAVE_TO_ALL_SUCCESS": "Werktijden succesvol gekopieerd naar alle andere inboxen",
      "SAVE_TO_ALL_ERROR": "Kopiëren van werktijden naar andere inboxen mislukt"
    },
    "PHONE": {
      "TITLE": "Telefooninstellingen",
      "SUBTITLE": "Configureer welke oproepen onder deze inbox worden weergegeven.",
      "UPDATE": "Instellingen opslaan",
      "EDIT": {
        "SUCCESS_MESSAGE": "Telefooninstellingen bijgewerkt"
      },
      "PHONE_NUMBERS": {
        "LABEL": "Telefoonnummers",
        "PLACEHOLDER": "+145123908635"
      }
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "Set your IMAP details",
      "NOTE_TEXT": "To enable SMTP, please configure IMAP.",
      "UPDATE": "Update IMAP settings",
      "TOGGLE_AVAILABILITY": "Enable IMAP configuration for this inbox",
      "TOGGLE_HELP": "Enabling IMAP will help the user to receive email",
      "EDIT": {
        "SUCCESS_MESSAGE": "IMAP settings updated successfully",
        "ERROR_MESSAGE": "Unable to update IMAP settings"
      },
      "ADDRESS": {
        "LABEL": "Address",
        "PLACE_HOLDER": "Address (Eg: imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Inloggen",
        "PLACE_HOLDER": "Inloggen"
      },
      "PASSWORD": {
        "LABEL": "Wachtwoord",
        "PLACE_HOLDER": "Wachtwoord"
      },
      "ENABLE_SSL": "Enable SSL"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "Reauthorize your MICROSOFT account"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "Set your SMTP details",
      "UPDATE": "Update SMTP settings",
      "TOGGLE_AVAILABILITY": "Enable SMTP configuration for this inbox",
      "TOGGLE_HELP": "Enabling SMTP will help the user to send email",
      "EDIT": {
        "SUCCESS_MESSAGE": "SMTP settings updated successfully",
        "ERROR_MESSAGE": "Unable to update SMTP settings"
      },
      "ADDRESS": {
        "LABEL": "Address",
        "PLACE_HOLDER": "Address (Eg: smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Inloggen",
        "PLACE_HOLDER": "Inloggen"
      },
      "PASSWORD": {
        "LABEL": "Wachtwoord",
        "PLACE_HOLDER": "Wachtwoord"
      },
      "DOMAIN": {
        "LABEL": "Domeinnaam",
        "PLACE_HOLDER": "Domeinnaam"
      },
      "ENCRYPTION": "Encryption",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "Open SSL Verify Mode",
      "AUTH_MECHANISM": "Authentication"
    },
    "EMAIL_DNS_CHECK": {
      "TITLE": "E-mailbezorging (DNS)",
      "SUB_TITLE": "Wij controleren elke werkdag de SPF-, DKIM-, DMARC- en MX-records van {domain}. Als iets ervoor zorgt dat ontvangende servers uw antwoorden weigeren of als ongewenst markeren, ontvangen beheerders een e-mail met de oplossing.",
      "RUN": "Controle uitvoeren",
      "RUN_SUCCESS": "DNS-controle voltooid",
      "RUN_ERROR": "De DNS-controle kon niet worden uitgevoerd, probeer het opnieuw",
      "NOT_CHECKED": "Nog niet gecontroleerd.",
      "CHECKED_AT": "Laatst gecontroleerd {time}.",
      "DNS_UNAVAILABLE": "De laatste controle kreeg geen antwoord van de nameservers van het domein. Het onderstaande resultaat is afkomstig van de controle daarvoor.",
      "SENDER": {
        "SMTP": "Antwoorden worden verstuurd via {host}.",
        "PLATFORM": "Antwoorden worden verstuurd via onze mailservers."
      },
      "STATUS": {
        "OK": "Alle records zijn in orde",
        "WARNING": "Sommige records kunnen beter",
        "ERROR": "Antwoorden komen mogelijk niet aan bij ontvangers",
        "UNKNOWN": "Onbekend"
      },
      "SEVERITY": {
        "ERROR": "Probleem",
        "WARNING": "Waarschuwing"
      },
      "FIX": "Los het op met dit DNS-record:",
      "RECORD_TYPE": "Type",
      "RECORD_HOST": "Naam",
      "RECORD_VALUE": "Waarde",
      "ISSUES": {
        "spf_missing": {
          "TITLE": "SPF-record ontbreekt",
          "DESCRIPTION": "Het domein geeft niet aan welke servers e-mail mogen versturen. Veel mailservers behandelen uw antwoorden dan als spam. Voeg een SPF-record toe dat {sender} toestaat."
        },
        "spf_multiple": {
          "TITLE": "Het domein heeft {count} SPF-records",
          "DESCRIPTION": "Een domein mag maar één SPF-record hebben. Bij meer records negeren ontvangende servers SPF en weigeren ze de e-mail vaak. Voeg ze samen tot één record."
        },
        "spf_not_authorized": {
          "TITLE": "SPF staat de server die uw antwoorden verstuurt niet toe",
          "DESCRIPTION": "Uw antwoorden worden verstuurd via {sender}, maar het SPF-record van het domein vermeldt deze server niet. Huidig record: {record}"
        },
        "spf_too_many_lookups": {
          "TITLE": "SPF-record vereist te veel DNS-opzoekingen",
          "DESCRIPTION": "Ontvangende servers stoppen met het controleren van SPF na {limit} DNS-opzoekingen, maar {sender}, de server die uw antwoorden verstuurt, wordt pas na {lookups} bereikt. Uw antwoorden mislukken daardoor voor SPF. Zet {sender} vooraan in het record en verwijder include-vermeldingen die het domein niet meer gebruikt."
        },
        "spf_lookups_others": {
          "TITLE": "Sommige afzenders in het SPF-record vallen buiten de opzoeklimiet",
          "DESCRIPTION": "Het SPF-record vereist {lookups} DNS-opzoekingen, ontvangende servers stoppen na {limit}. Uw antwoorden worden op tijd herkend en slagen, maar e-mail van deze afzenders mislukt voor SPF: {senders}. Verwijder include-vermeldingen die het domein niet meer gebruikt."
        },
        "spf_malformed": {
          "TITLE": "SPF-record is defect",
          "DESCRIPTION": "Ontvangende servers kunnen het SPF-record van het domein niet lezen, waardoor het uw antwoorden niet beschermt. Het probleem zit in: {terms}. Vervang het record door de gecorrigeerde versie."
        },
        "dkim_missing": {
          "TITLE": "DKIM-handtekening is niet ingesteld",
          "DESCRIPTION": "Wij vonden geen DKIM-sleutel op {selectors}. Zonder sleutel worden uw antwoorden niet ondertekend en komen ze vaker in de spam terecht. Schakel DKIM-ondertekening voor het domein in bij uw e-mailprovider."
        },
        "dmarc_missing": {
          "TITLE": "DMARC-record ontbreekt",
          "DESCRIPTION": "Grote e-mailproviders zoals Gmail en Microsoft verwachten een DMARC-record. Zonder dit record komen uw antwoorden vaker in de spam terecht."
        },
        "dmarc_fails": {
          "TITLE": "DMARC laat ontvangers uw antwoorden weigeren",
          "DESCRIPTION": "Het DMARC-beleid van het domein is „{policy}” en uw antwoorden slagen noch voor SPF noch voor DKIM, waardoor ontvangers ze weigeren of in de spam plaatsen. Los eerst SPF en DKIM hierboven op."
        },
        "dmarc_blocks_platform": {
          "TITLE": "DMARC blokkeert antwoorden die via onze mailservers worden verstuurd",
          "DESCRIPTION": "Deze inbox verstuurt antwoorden via onze mailservers, maar het DMARC-beleid van het domein is „{policy}”, waardoor ontvangers ze weigeren of in de spam plaatsen. Stel voor deze inbox SMTP van uw eigen mailserver in."
        },
        "mx_missing": {
          "TITLE": "Het domein heeft geen MX-record",
          "DESCRIPTION": "Zonder MX-record kan niemand e-mail naar het domein sturen, dus klanten kunnen niet reageren op uw antwoorden."
        }
      }
    },
    "NOTE": "Note: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Website Avatar",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Avatar deleted successfully",
              "ERROR_MESSAGE": "Er is een fout opgetreden, probeer het opnieuw"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Website naam",
          "PLACE_HOLDER": "Voer de naam van je website in (bv. Acme Inc)",
          "ERROR": "Please enter a valid website name"
        },
        "WELCOME_HEADING": {
          "LABEL": "Welkom op titel",
          "PLACE_HOLDER": "Hi there!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Welkom Tagline",
          "PLACE_HOLDER": "We maken het eenvoudig om met ons te verbinden. Vraag ons iets of deel uw feedback."
        },
        "REPLY_TIME": {
          "LABEL": "Reply Time",
          "IN_A_FEW_MINUTES": "In enkele minuten",
          "IN_A_FEW_HOURS": "Over een paar uur",
          "IN_A_DAY": "In één dag"
        },
        "WIDGET_COLOR_LABEL": "Kleur van widget",
        "WIDGET_BUBBLE_POSITION_LABEL": "Widget Bubble Position",
        "UNREAD_MESSAGES_MAX_HEIGHT": {
          "LABEL": "Maximale hoogte van ongelezen berichten (px)",
          "PLACE_HOLDER": "Geen limiet",
          "HELP_TEXT": "Beperk de maximale hoogte van de pop-up met ongelezen berichten in pixels. Laat leeg voor het standaardgedrag (geen limiet)."
        },
        "WIDGET_BUBBLE_TYPE_LABEL": "Widget Bubble Type",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Chat met ons",
          "LABEL": "Widget Bubble Launcher Title",
          "PLACE_HOLDER": "Chat met ons"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Update Widget Settings",
          "API": {
            "SUCCESS_MESSAGE": "Widget settings updated successfully",
            "ERROR_MESSAGE": "Unable to update widget settings"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Preview",
          "SCRIPT": "Script"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Left",
          "RIGHT": "Right"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Standard",
          "EXPANDED_BUBBLE": "Expanded Bubble"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "Default",
        "CHAT": "Chat"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "Reageert meestal binnen een paar minuten",
        "IN_A_FEW_HOURS": "Reageert meestal binnen een paar uur",
        "IN_A_DAY": "Reageert meestal binnen een dag"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Start Chat",
        "CHAT_INPUT_PLACEHOLDER": "Typ uw bericht"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "We are Online",
          "OFFLINE": "We zijn momenteel afwezig"
        },
        "USER_MESSAGE": "Hi",
        "AGENT_MESSAGE": "Hello"
      },
      "BRANDING_TEXT": "Mogelijk gemaakt door JARABOT",
      "SCRIPT_SETTINGS": "\n      window.jarabotSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": "Microsoft",
      "GOOGLE": "Google",
      "OTHER_PROVIDERS": "Other Providers"
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Website",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "SMS_BRANA": "SMS Brana",
      "DIDWW": "DIDWW",
      "EMAIL": "E-mailadres",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "API-kanaal",
      "PHONE": "SIP-telefoon",
      "INSTAGRAM": "Instagram",
      "SALESFORCE": "Salesforce",
      "ALLEGRO": "Allegro",
      "KAUFLAND": "Kaufland"
    }
  }
}
